import comp from "./ValueComponent";
export default comp;
